<div *ngIf="isAttributionParLots()">
    <app-form-input-error [activeForm]="parentForm" [name]="rg4"></app-form-input-error>
    <div *ngFor="let obj of attribution.lotMarche; let i = index">
        <fieldset>
            <legend>
                {{ step5.getspan12 | translate }}
            </legend>
            <button *ngIf="!disabled" class="btn btn-outline-primary" (click)="removelotMarche(i)">{{
                step5.getdeletelot |
                translate }}</button>
            <app-lot-marche [uid]="getUid() + '_index_' + (i + 1)" [index]="i" [parentForm]="parentForm"
                [disabled]="disabled" [lotMarche]="obj" [index]="i+1"></app-lot-marche>
        </fieldset>
    </div>
    <button *ngIf="!disabled" class="btn btn-outline-primary" (click)="addlotMarche()">{{ step5.getaddlot | translate }}</button>
</div>
<span *ngIf="!isAttribue()">{{ step5.getspan17 | translate }}</span>
<span *ngIf="isAttribue() && !isAttributionParLots()">{{ step5.getspan19 | translate }}</span>
